import React, { FC } from 'react'
import SearchIcon from '../Icons/Search'

import './Inputs.scss'

type SearchableInputProps = {
  labels: any
  searchTerm: any
  setSearchTerm: any
}

const SearchableInput: FC<SearchableInputProps> = ({ searchTerm, setSearchTerm }) => {
  const handleChange = (event: any) => {
    setSearchTerm(event.target.value)
  }

  return (
    <>
      <div className={`search-text-input`}>
        <input
          type='text'
          className={`search-text-input__input`}
          placeholder='Search'
          value={searchTerm}
          onChange={handleChange}
        />
        <SearchIcon color='#9C9EB2' size={16} />
      </div>
    </>
  )
}

export default SearchableInput
